/*

? First, let's import the interface that will describe the shape of our boost object.

*/

import StateInterface from "../state-interface";

/*

& Now let's describe an initial state for the boost object. This is the state that will be used when the app first fires up. Think of it like a placeholder.

*/

export const meta_campaign: StateInterface["meta_campaign"] = {
	_id: "",

	campaign: [
		{
			id: "",
			name: "",
			status: "",
			objective: "",
			insights: {
				campaign_name: "",
				leads: 0,
				qualified_leads: 0,
				cpl: 0,
				impressions: 0,
				cpm: 0,
				cpc: 0,
				ctr: 0,
				spend: 0,
				duration_in_days: 0,
				start_time: "",
				end_time: "",
			},
			adsets: [
				{
					name: "",
					campaign_id: "",
					status: "ACTIVE",
					bid_strategy: "",
					optimization_goal: "",
					daily_budget: 0,
					lifetime_budget: 0,
					start_time: "",
					end_time: "",
					targeting: {
						age_min: 0,
						age_max: 0,
						genders: [],
						geo_locations: {
							countries: [],
							cities: [
								{
									key: "",
									radius: 0,
									distance_unit: "kilometer",
								},
							],
						},
						publisher_platforms: [],
						facebook_positions: [],
						instagram_positions: [],
						interests: [],
					},
				},
			],
			ads: [
				{
					name: "",
					adset_id: "",
					status: "ACTIVE",
					creative: {
						name: "",
						object_story_spec: {
							page_id: "",
							lead_gen_form_id: "",
							link_data: {
								message: "",
								link: "",
								image_hash: "",
								call_to_action: {
									type: "",
									value: {
										link: "",
										lead_gen_form_id: "",
									},
								},
							},
						},
					},
					url_tags: "",
				},
			],
		},
	],

	metrics: {
		property_id: "",
		campaign_insights: {
			campaign_name: "",
			leads: 0,
			qualified_leads: 0,
			cpl: 0,
			impressions: 0,
			cpm: 0,
			cpc: 0,
			ctr: 0,
			spend: 0,
			duration_in_days: 0,
			start_time: "",
			end_time: "",
		},
		created_at: new Date(),
		updated_at: new Date(),
		deleated_at: null,
		is_deleted: false,
	},
};
